export interface ProlongEmployee {
  id: number;
  state: string;
  full_name: string;
  iban: string;
  expire_date: string;
}

export interface SalaryCardsProlongResponse {
  business_key: string;
  prolong_employee: ProlongEmployee[];
  result: string;
  subscribe: 'Y' | 'N';
}

export interface SalaryCardsProlongParams {
  search?: string;
}

export interface SelectedEmployee {
  id: number;
  full_name: string;
  telefon: string;
}

export interface SalaryCardsProlongSubmitResponse {
  business_key: string;
  result: string;
  selected_employee: SelectedEmployee[];
}

export interface SalaryCardsProlongSignResponse {
  asan_imza_id: string;
  business_key: string;
  form_id: string;
  path_url: string;
  phone: string;
  result: string;
  timer: string;
  type: string;
  verification_code: string;
}

export interface ExistingSalaryCard {
  id: number;
  fullName: string;
  accountNumber: string;
  expiryDate: string;
  status: string;
}

export interface ExtensionEmployeeWithPhone {
  id: number;
  fullName: string;
  phone: string;
}

export interface ExtensionPhoneNumbersState {
  business_key: string;
  selected_employee: SelectedEmployee[];
}

export interface SalaryCardsProlongSubmitRequest {
  business_key: string;
  prolong_employees_id: number[];
}

export interface SalaryCardsProlongPhonesSubmitRequest {
  business_key: string;
  final_employee: SelectedEmployee[];
}

export const mapProlongEmployee = (employee: ProlongEmployee): ExistingSalaryCard => ({
  id: employee.id,
  fullName: employee.full_name,
  accountNumber: employee.iban,
  expiryDate: employee.expire_date,
  status: employee.state,
});

export const formatTelefonForDisplay = (telefon: string) => telefon.replace(/^994/, '');

export const formatPhoneForTelefon = (phone: string) => {
  const digits = phone.replace(/\s+/g, '');

  return `994${digits}`;
};

export const mapSelectedEmployeeToDisplay = (
  employee: SelectedEmployee
): ExtensionEmployeeWithPhone => ({
  id: employee.id,
  fullName: employee.full_name,
  phone: formatTelefonForDisplay(employee.telefon),
});

export const mapDisplayToSelectedEmployee = (
  employee: ExtensionEmployeeWithPhone
): SelectedEmployee => ({
  id: employee.id,
  full_name: employee.fullName,
  telefon: formatPhoneForTelefon(employee.phone),
});
